import { render, staticRenderFns } from "./ProductsTableComponent.vue?vue&type=template&id=27ec9ae7&scoped=true"
import script from "./ProductsTableComponent.vue?vue&type=script&lang=js"
export * from "./ProductsTableComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductsTableComponent.vue?vue&type=style&index=0&id=27ec9ae7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ec9ae7",
  null
  
)

export default component.exports